import {fetch} from "utils/dataAccess";

// The Sylius shipping methods unknown to the Marketplace, see the API's SyliusShippingMethodCandidateController.
export function listSyliusCandidates() {
    return fetch('/shipping_method_candidates').then(response => response.json());
}

// Reads Sylius again: returns the candidates, the fields filled from Sylius and the drifts.
export function fetchSyliusCandidates() {
    return fetch('/shipping_method_candidates/fetch', {method: 'POST'}).then(response => response.json());
}
